import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { LogService } from '@app/services/log/log.service';
import { API_CONFIG, EXPERIMENT_RUNS_CONFIG } from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class RunExperimentService {

    constructor(private httpClient: HttpClient, private logService: LogService, @Optional() @Inject('INITIAL_REFERER') protected referer: string) { }

    public createRunExperiment(): Observable<any> {
        const landableURL = API_CONFIG.host + EXPERIMENT_RUNS_CONFIG.api.run;
        return this.httpClient.post<any>(landableURL, undefined).pipe(
            map((res) => res),
            shareReplay(),
            catchError((error) => {
                this.logError(error);
                return of(undefined);
            })
        );
    }

    private logError(error: HttpErrorResponse): void {
        this.logService.log(error.name + error.message);
    }
}